import Dialog from 'material-ui/Dialog'
import intl from 'react-intl-universal'
import PedidosForm from './pedidos-form'
import { useGlobalContext } from 'hooks/useGlobalContext'
import PropTypes from 'prop-types'

const ModalConfiguration = ({ open, handleClose }) => {

  const { showFeedback } = useGlobalContext()

  return (
    <>
      <Dialog
        title={intl.get('master-data.menus.configuration')}
        contentStyle={{ width: '600px' }}
        open={open}
        onRequestClose={handleClose}
        autoScrollBodyContent
      >
        <PedidosForm
          open
          handleClose={handleClose}
          handleToast={(message) => showFeedback(message)}
        />
      </Dialog>
    </>
  )
}

ModalConfiguration.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func
}

export default ModalConfiguration
